"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = forkPutEffect;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// In redux-saga, if we call the following effects in order, we might miss the take('C').
// 1. take('A')
// 2. put({ type: 'B' })
// 3. take('C')
// We need to modify step 2 to:
// 2. fork(function* () { yield put({ type: 'B' }) })
// This is a helper function for this purpose.
function forkPutEffect() {
  for (var _len = arguments.length, actions = new Array(_len), _key = 0; _key < _len; _key++) {
    actions[_key] = arguments[_key];
  }

  return (0, _effects.fork)( /*#__PURE__*/_regenerator["default"].mark(function forkPut() {
    var _iterator, _step, action;

    return _regenerator["default"].wrap(function forkPut$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _iterator = _createForOfIteratorHelper(actions);
            _context.prev = 1;

            _iterator.s();

          case 3:
            if ((_step = _iterator.n()).done) {
              _context.next = 9;
              break;
            }

            action = _step.value;
            _context.next = 7;
            return (0, _effects.put)(action);

          case 7:
            _context.next = 3;
            break;

          case 9:
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](1);

            _iterator.e(_context.t0);

          case 14:
            _context.prev = 14;

            _iterator.f();

            return _context.finish(14);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, forkPut, null, [[1, 11, 14, 17]]);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJmb3JrUHV0RWZmZWN0IiwiYWN0aW9ucyIsImZvcmsiLCJmb3JrUHV0IiwiYWN0aW9uIiwicHV0Il0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3NhZ2FzL2VmZmVjdHMvZm9ya1B1dC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmb3JrLCBwdXQgfSBmcm9tICdyZWR1eC1zYWdhL2VmZmVjdHMnO1xuXG4vLyBJbiByZWR1eC1zYWdhLCBpZiB3ZSBjYWxsIHRoZSBmb2xsb3dpbmcgZWZmZWN0cyBpbiBvcmRlciwgd2UgbWlnaHQgbWlzcyB0aGUgdGFrZSgnQycpLlxuLy8gMS4gdGFrZSgnQScpXG4vLyAyLiBwdXQoeyB0eXBlOiAnQicgfSlcbi8vIDMuIHRha2UoJ0MnKVxuXG4vLyBXZSBuZWVkIHRvIG1vZGlmeSBzdGVwIDIgdG86XG4vLyAyLiBmb3JrKGZ1bmN0aW9uKiAoKSB7IHlpZWxkIHB1dCh7IHR5cGU6ICdCJyB9KSB9KVxuXG4vLyBUaGlzIGlzIGEgaGVscGVyIGZ1bmN0aW9uIGZvciB0aGlzIHB1cnBvc2UuXG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIGZvcmtQdXRFZmZlY3QoLi4uYWN0aW9ucykge1xuICByZXR1cm4gZm9yayhmdW5jdGlvbiogZm9ya1B1dCgpIHtcbiAgICBmb3IgKGNvbnN0IGFjdGlvbiBvZiBhY3Rpb25zKSB7XG4gICAgICB5aWVsZCBwdXQoYWN0aW9uKTtcbiAgICB9XG4gIH0pO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUFBOzs7Ozs7OztBQUVBO0FBQ0E7QUFDQTtBQUNBO0FBRUE7QUFDQTtBQUVBO0FBRWUsU0FBU0EsYUFBVCxHQUFtQztFQUFBLGtDQUFUQyxPQUFTO0lBQVRBLE9BQVM7RUFBQTs7RUFDaEQsT0FBTyxJQUFBQyxhQUFBLDZDQUFLLFNBQVVDLE9BQVY7SUFBQTs7SUFBQTtNQUFBO1FBQUE7VUFBQTtZQUFBLHVDQUNXRixPQURYO1lBQUE7O1lBQUE7O1VBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTs7WUFDQ0csTUFERDtZQUFBO1lBRVIsT0FBTSxJQUFBQyxZQUFBLEVBQUlELE1BQUosQ0FBTjs7VUFGUTtZQUFBO1lBQUE7O1VBQUE7WUFBQTtZQUFBOztVQUFBO1lBQUE7WUFBQTs7WUFBQTs7VUFBQTtZQUFBOztZQUFBOztZQUFBOztVQUFBO1VBQUE7WUFBQTtRQUFBO01BQUE7SUFBQSxHQUFVRCxPQUFWO0VBQUEsQ0FBTCxFQUFQO0FBS0QifQ==